import script from "./QDistrictItem.vue?vue&type=script&setup=true&lang=js"
export * from "./QDistrictItem.vue?vue&type=script&setup=true&lang=js"

import "./QDistrictItem.vue?vue&type=style&index=0&id=1e6f0bc7&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e6f0bc7"]])

export default __exports__